import * as Api from '@ViewModels';
import { IEtlMetadata } from '@ViewModels';
import { css } from 'aphrodite';
import React from 'react';
import { ETLStage } from '../ETLStage';
import { styleSheet } from './styles';

interface IETLStagesProps {
	etl: IEtlMetadata;
	provider: Api.IntegrationProvider;
	impersonationContext?: Api.IImpersonationContext;
	anyStageInProgress: boolean;
	isPipelineSuspended: boolean;
}

export const ETLStages: React.FC<IETLStagesProps> = ({
	etl,
	provider,
	impersonationContext,
	anyStageInProgress,
	isPipelineSuspended,
}) => {
	const stages = ['extract', 'transform', 'load'] as const;
	const renderStages = () => {
		return stages.map(stage => {
			const metadata = etl[stage];
			if (!metadata) return null;

			return (
				<ETLStage
					key={stage}
					label={stage[0].toUpperCase() + stage.slice(1)}
					metadata={metadata}
					preProcessMetadata={etl.preProcess}
					provider={provider}
					stage={stage}
					impersonationContext={impersonationContext}
					anyStageInProgress={anyStageInProgress}
					isPipelineSuspended={isPipelineSuspended}
				/>
			);
		});
	};

	return <div className={css(styleSheet.container)}>{renderStages()}</div>;
};
